(function () {
  function stripDashes(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue && /[\u2014\u2013]/.test(node.nodeValue)) {
        node.nodeValue = node.nodeValue.replace(/[\u2014\u2013]/g, '-');
      }
    }
  }

  function run() {
    if (document.title) {
      document.title = document.title.replace(/[\u2014\u2013]/g, '-');
    }
    stripDashes(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (event) {
    stripDashes(event.target);
  });
})();
